(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Sticky header (Dawn) */
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }
      this.currentScrollTop = 0; this.preventReveal = false; this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this); this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() { this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver() { let o = new IntersectionObserver((e,ob)=>{ this.headerBounds = e[0].intersectionRect; ob.disconnect(); }); o.observe(this.header); }
    onScroll() {
      const s = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (s > this.currentScrollTop && s > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header'); if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this));
      } else if (s < this.currentScrollTop && s > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(()=>{ this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (s <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = s;
    }
    hide() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
    closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(d => d.close()); }
    closeSearchModal() { this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  /* Announcement offset */
  (function setAnnouncementOffset(){
    function compute(){
      const ann = document.querySelector('.announcement-bar, .shopify-section-group-header-group .announcement-bar-section, .shopify-section-announcement-bar');
      const h = ann ? ann.offsetHeight : 0;
      document.documentElement.style.setProperty('--annc-h', h + 'px');
    }
    compute();
    window.addEventListener('resize', compute);
    document.addEventListener('shopify:section:load', compute);
  })();

  // Mobile drawer
  (function(){
    const overlay = document.getElementById('bdOverlay');
    const drawer = document.getElementById('bdDrawer');
    function open(){ overlay.classList.add('is-open'); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
    function close(){ overlay.classList.remove('is-open'); drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
    window.bdOpenMenu = open; window.bdCloseMenu = close;
    overlay && overlay.addEventListener('click', close);
    document.getElementById('bdClose') && document.getElementById('bdClose').addEventListener('click', close);

    // Accordion (one open at a time)
    document.querySelectorAll('.bd-acc-btn').forEach(btn=>{
      btn.addEventListener('click', ()=>{
        const sub = btn.parentElement.querySelector('.bd-sub');
        const openNow = sub.style.display === 'block';
        document.querySelectorAll('.bd-sub').forEach(s=>s.style.display='none');
        document.querySelectorAll('.bd-acc-btn').forEach(b=>b.setAttribute('aria-expanded','false'));
        if(!openNow){ sub.style.display='block'; btn.setAttribute('aria-expanded','true'); }
      });
    });
  })();

  // Desktop dropdowns (click toggle, one open at a time)
  (function(){
    const mq = window.matchMedia('(min-width: 990px)');
    const items = Array.from(document.querySelectorAll('.bd-dropdown'));
    const buttons = Array.from(document.querySelectorAll('.bd-dropdown > .bd-topbtn'));

    function closeAll(){
      items.forEach(li=>{
        li.classList.remove('is-open');
        const btn = li.querySelector('.bd-topbtn');
        if(btn){ btn.setAttribute('aria-expanded','false'); }
      });
    }

    function bind(){
      buttons.forEach(btn=>{
        btn.addEventListener('click', (e)=>{
          if(!mq.matches) return;
          const li = btn.closest('.bd-dropdown');
          const already = li.classList.contains('is-open');
          closeAll();
          if(!already){
            li.classList.add('is-open');
            btn.setAttribute('aria-expanded','true');
          }
        });
      });

      document.addEventListener('click', (e)=>{
        if(!mq.matches) return;
        const inMenu = e.target.closest('.bd-dropdown') || e.target.closest('.bd-menu');
        if(!inMenu){ closeAll(); }
      });

      document.addEventListener('keydown', (e)=>{
        if(e.key === 'Escape'){ closeAll(); }
      });

      window.addEventListener('scroll', closeAll, { passive:true });
    }
    bind();
  })();

  } catch(e) { console.error(e); }
})();
})();
